import { Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-placeholder-company-invitation',
  templateUrl: './placeholder-company-invitation.component.html',
  styleUrls: ['./placeholder-company-invitation.component.css'],
  imports: [
    MatDividerModule
  ]
})
export class PlaceholderCompanyInvitationComponent {

}
